import { Currency } from '../../../../Generated/Raven-Demeter';
import { TableHeader } from '../../../Components/Tables/Table/TableDefinitions';
import languageService from '../../../Services/Language/LanguageService';
import { translationKeys } from '../../../Services/Language/TranslationDefinitions';
import { MarketPriceSymbolContractCompositeModel } from '../MarketIntelligenceReportsDefinitions';

export type ArbitrageTableRow = {
    arbitrageName: string;
    dollar: number;
    euro: number;
    pound: number;
};

export type SpreadTableRow = {
    spreadName: string;
    previousClose: number;
    open: number;
    highPrice: number;
    lowPrice: number;
    lastPrice: number;
    openInterestNetChange: number;
    volume: number;
};

export type CaseCorrectedUnitOfMeasureConversionMap = {
    hundredWeight: number;
    kilogram: number;
    metricTon: number;
    pound: number;
    shortTon: number;
};

export type MarketPricesTableRow = MarketPriceSymbolContractCompositeModel & { contractDate: string };

export const marketPricesTableHeaders: TableHeader<MarketPricesTableRow>[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.contractDate),
        field: 'contractDate',
        minimumWidth: 100,
        dataFormat: 'date',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.settle),
        field: 'settlementPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.settleChange),
        field: 'netChange',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.high),
        field: 'highPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.low),
        field: 'lowPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.openInterest),
        field: 'openInterest',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.openInterestNetChange),
        field: 'openInterestNetChange',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
];

export const spreadTableHeaders: TableHeader<SpreadTableRow>[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.contractDate),
        field: 'spreadName',
        minimumWidth: 200,
        dataFormat: 'string',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.previousClose),
        field: 'previousClose',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.open),
        field: 'open',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.high),
        field: 'highPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.low),
        field: 'lowPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.last),
        field: 'lastPrice',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.openInterestNetChange),
        field: 'openInterestNetChange',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.volume),
        field: 'volume',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
];

export const arbitrageTableHeaders: TableHeader<ArbitrageTableRow>[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.marketIntelligenceReports.headers.contractDate),
        field: 'arbitrageName',
        minimumWidth: 100,
        dataFormat: 'string',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.currency[Currency.Usd]),
        field: 'dollar',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.currency[Currency.Eur]),
        field: 'euro',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.currency[Currency.Gbp]),
        field: 'pound',
        minimumWidth: 100,
        dataFormat: 'currency',
    },
];
